import { observer } from "mobx-react";
import { useState } from "react";

import Button from "components/UI/Button/Button";
import Icon from "components/UI/IconSVG/Icon";
import ProjectTitle from "pages/Projects/components/Project/ProjectTitle/ProjectTitle";
import ProjectsDraftsAbstractRow from "../ProjectsDraftsAbstractRow/ProjectsDraftsAbstractRow";
import ProjectLinkButton from "pages/Projects/components/ProjectLinkButton/ProjectLinkButton";
import ProjectCounters from "pages/Projects/components/Project/ProjectCounters/ProjectCounters";
import ProjectSettingsMobile from "pages/Projects/components/Project/mobile-ver/ProjectSettingsMobile/ProjectSettingsMobile";
import ProjectPropertyColumn from "pages/Projects/components/ProjectPropertyColumn/ProjectPropertyColumn";
import FoldableSection from "components/UI/FoldableSection/FoldableSection";
import ProjectDraftsInfo from "../ProjectDraftsInfo/ProjectDraftsInfo";

import AppStore from "AppStore";
import popupStore from "components/Popup/PopupStore";

import {
  calcTotalProjectActions,
  findActivityCount,
  formatCity,
} from "../../../Projects/ProjectsConstants";

import "./ProjectsDraftsRow.scss";

const ProjectsDraftsRow = observer(({ project, isMobile }) => {
  const [expanded, setExpanded] = useState(false);
  const [renderReports, setRenderReports] = useState(false);
  const [isShowSettings, setIsShowSettings] = useState(false);
  const activities = project?.activities;
  const actions = calcTotalProjectActions(project).toLocaleString();
  const reviewsCount = findActivityCount(activities, "MAIN.REVIEW");
  const { price } = project;
  const isEditing = AppStore.editingTitle && AppStore.editingProjectId === project.id;

  function invertExpanded(e) {
    if (AppStore.editingTitle && AppStore.editingProjectId === project.id) {
      return;
    }
    if (e.target.closest(".project-editing-title__button-save")) {
      return;
    }

    setExpanded(!expanded);
    if (!expanded)
      setRenderReports(true);
  }

  const onTransitionEnd = () => {
    if (!expanded)
      setRenderReports(false);
  };

  if (!project) return null;

  return (
    <FoldableSection className="projects-archive-row" expanded={expanded} onTransitionEnd={onTransitionEnd}>
      <ProjectsDraftsAbstractRow className="projects-drafts-row">
        <div className="projects-drafts-row__title-container">
          {!project.bots 
            ? <div className="projects-archive-row__title-section" onClick={invertExpanded}>
                <Icon className={`projects-archive-row__title-section-icon ${expanded ? "expanded" : ""}`} sprite="projects" name="accordion" color="#4F4F4F" />
                <ProjectTitle store={AppStore} project={project} expanded={false} isMobile={isMobile} />
              </div> 
            : <ProjectTitle store={AppStore} project={project} expanded={false} isMobile={isMobile} />
          }
          {!isMobile && (isEditing
            ? <></>
            : <button type="button" aria-label="Редактировать" onClick={() => { AppStore.startEditingProjectTitle(project.id); AppStore.setEditingTitle(true); AppStore.setNewTitle(project.title); }}>
                <Icon className="projects-drafts-row__button-edit" sprite="projects" name="edit" color="#1E1E1E" />
              </button>
          )}
          {isMobile && 
            <button type="button" aria-label="Открыть все настройки" onClick={() => { popupStore.open("project-settings-mobile"); setIsShowSettings(true); }}>
              <Icon className="projects-drafts-row__button-mobile-config" sprite="projects" name="mobile-config" color="#1E1E1E" width={4} height={18} />
            </button>
          }
        </div>
        <div className="projects-drafts-row__info">
          {!isMobile && <ProjectLinkButton style={{ visibility: project.link ? "visible" : "hidden" }} link={project.link} />}
          <div className="projects-drafts-row__info-status">{project.testing ? "Ожидает запуска" : "Ожидает оплаты"}</div>
          <ProjectCounters actions={actions} reviewsCount={reviewsCount} projectBots={project.bots} projectTest={project.testing} />
          {project.bots && <ProjectPropertyColumn className="project-property-column__key-phrases" title="Ключевые запросы" text={project.searchPhrases || "—"} project={project}   dataEmpty={!project.searchPhrases || project.searchPhrases === "—"} />}
          <div className="projects-archive-row__info-city">{formatCity(project.city)}</div>
        </div>
        <div className="projects-drafts-row__buttons">
          <Button title={price ? "Списать" : "Запустить"} boldText={price ? `${project.price.toLocaleString()} ₽` : undefined} onClick={() => { AppStore.payProject(project) }} />
          <button type="button" aria-label="Удалить" className="projects-drafts-row__wrapper" onClick={() => { AppStore.deleteProjectWithConfirm(project) }}>
            <Icon className="projects-drafts-row__wrapper-delete-icon" sprite="projects" name="delete" color="#FF7373" />
          </button>
        </div>

        {isMobile && isShowSettings && <ProjectSettingsMobile store={AppStore} project={project} isMobile={isMobile} />}
      </ProjectsDraftsAbstractRow>
        
      {!project.bots && renderReports && <ProjectDraftsInfo project={project} />}
    
    </FoldableSection>
  );
});

export default ProjectsDraftsRow;
